import React from 'react';
import Unsubscription from './Unsubscription';
import { AppState } from '../../types/types';

interface Props {
    appState: AppState
}

const LoggedIn : React.FC<Props> = ({appState}) => {
    return <>
        <Unsubscription appState={appState} />
    </>
}

export default LoggedIn;